import type { ColumnSortValue, TableSortDirection } from '../DataTable.types'
import { compareColumnSortValues } from './compareColumnSortValues'
import { isBlankSortValue } from './isBlankSortValue'

export function sortTableRows<T>(
  rows: readonly T[],
  getSortValue: (row: T) => ColumnSortValue,
  direction: TableSortDirection
): T[] {
  const directionFactor = direction === 'asc' ? 1 : -1
  return [...rows].sort((leftRow, rightRow) => {
    const left = getSortValue(leftRow)
    const right = getSortValue(rightRow)
    const comparison = compareColumnSortValues(left, right)
    if (isBlankSortValue(left) || isBlankSortValue(right)) {
      return comparison
    }
    return comparison * directionFactor
  })
}
